import React, { useCallback, useState } from 'react'
import { Badge, Card, Col, Collapse, Container, Table } from 'react-bootstrap'
import Avatar from '../components/common/Avatar'
import { useAuth } from '../contexts/auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

const changePasswordUrl = window.__env.CHANGE_PASSWORD_URL;

export default function Account() {
  const { loggedUser } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const toggleChangePassword = useCallback(() => setShowChangePassword(v => !v), []);

  return loggedUser ? (
    <Container className="mt-3">
      <Card className="mb-3">
        <Card.Body>
          <div className="d-flex align-items-center mb-3">
            <Avatar user={loggedUser} />
            <Col className="ms-2">
              <h5 className="mb-0">{loggedUser.preferred_username}</h5>
              <h6 className="text-muted mb-0">{loggedUser.email}</h6>
            </Col>
          </div>

          <Table>
            <thead>
              <tr>
                <th style={{ width: '40%' }}></th>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="col">Name</th>
                <td className="text-end">{loggedUser.name}</td>
              </tr>
              <tr>
                <th scope="col">Organization</th>
                <td className="text-end">{loggedUser.organizationName}</td>
              </tr>
              {loggedUser.groups && (
                <tr>
                  <th scope="col">Groups</th>
                  <td className="text-end">{loggedUser.groups.map((group, index) => <Badge key={index} className="me-2">{group}</Badge>)}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="p-1">
          <button className="d-block w-100 text-start toggle-button" onClick={toggleChangePassword}>
            <FontAwesomeIcon icon={solid('key')} />
            <span className="ms-2">Change Password</span>
          </button>

          <Collapse in={showChangePassword}>
            <div>
              <div className="p-3 text-center">
                If you want to set a new password <a href={changePasswordUrl}>click here</a>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    </Container>
  ) : null;
}
